// extracted by mini-css-extract-plugin
module.exports = {"title":"SY7b6D"};